import api from './api';

export interface EmpresaResumen {
  id: number;
  nombre: string;
  slug: string;
}

export const empresaService = {
  async getMisEmpresas(): Promise<EmpresaResumen[]> {
    const { data } = await api.get('/empresas/mis');
    return data;
  },
};

